import React, { useContext } from 'react';

import { useQueryClient } from '@tanstack/react-query';
import classes from './styles.module.scss';

import NonFavoritesIcon from '../../../Dashboard/Jobs/MyJobs/Icons/NonFavoritesIcon';
import FavoritesIcon from '../../../Dashboard/Jobs/MyJobs/Icons/FavoritesIcon';

import { UiContext } from '../../../../context/UiContext';
import AdminService from '../../../../services/AdminService';

export default function CompanyBooleanFavorite({
  isFavorite,
  companyId,
  refetch,
}) {
  const { setIsFetching } = useContext(UiContext);

  const queryClient = useQueryClient();

  const refetchWithQueryClient = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['companies'],
    });
  };

  const addCompanyToFavorites = async (event) => {
    event.stopPropagation();
    try {
      setIsFetching(true);

      await AdminService.addCompanyToFavorites({ id: companyId });

      if (refetch) {
        await refetch();
      } else {
        await refetchWithQueryClient();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsFetching(false);
    }
  };

  const removeCompanyFromFavorites = async (event) => {
    event.stopPropagation();
    try {
      setIsFetching(true);

      await AdminService.removeCompanyFromFavorites({ id: companyId });

      if (refetch) {
        await refetch();
      } else {
        await refetchWithQueryClient();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <div
      className={classes.CompanyBooleanFavorite}
      onClick={isFavorite ? removeCompanyFromFavorites : addCompanyToFavorites}
    >
      {isFavorite ? (
        <FavoritesIcon size={20} />
      ) : (
        <NonFavoritesIcon size={20} />
      )}
    </div>
  );
}
